interface PaginationInfoProps {
  total: number;
  start: number;
  end: number;
  itemName?: string; // e.g., "projects", "invoices"
}

export function PaginationInfo({ total, start, end, itemName = 'items' }: PaginationInfoProps) {
  if (total === 0) {
    return <p className="text-sm text-muted-foreground">No {itemName} found</p>;
  }

  return (
    <p className="text-sm text-muted-foreground">
      Showing <span className="font-medium">{start}</span> to{' '}
      <span className="font-medium">{end}</span> of{' '}
      <span className="font-medium">{total}</span> {itemName}
    </p>
  );
}
